// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".certificate-dec .left[data-v-5eee732e] {\n  width: 120px;\n}\n.certificate-dec .right[data-v-5eee732e] {\n  flex: 1;\n  padding-left: 20px;\n}", ""]);
// Exports
module.exports = exports;
